var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { api } from 'network/network';
/**
 * Возвращает приблизительные даты доступности экскурсии на указанный месяц.
 */
export function fetchExcursionAvailabilityApprox(id, monthIso) {
    return __awaiter(this, void 0, void 0, function* () {
        const q = { month: monthIso };
        const result = yield api('get', '/Excursion/' + id + '/Availability', q);
        return !result.errors ? result.response : { errors: result.errors };
    });
}
/**
 * Подбирает стоимость экскурсии.
 */
export function fetchExcursionPrice(id, dateIso, adultCount, childAges, tourId) {
    return __awaiter(this, void 0, void 0, function* () {
        const q = { date: dateIso, adultCount, childAges, tourId };
        const result = yield api('get', '/Excursion/' + id + '/Price', q);
        return !result.errors ? result.response : { errors: result.errors };
    });
}
/**
 * Добавляет экскурсию в корзину.
 */
export function addExcursionToCart(id, dateIso, adultCount, childAges, serializedPrice) {
    return __awaiter(this, void 0, void 0, function* () {
        const body = { date: dateIso, adultCount, childAges, excursionSerialized: serializedPrice };
        const result = yield api('post', '/Excursion/' + id + '/AddToCart', body);
        return !result.errors ? [] : result.errors;
    });
}
